import React from 'react';

function SerpPreview({ title = '', metaDesc = '', snippet = '', isDefinitionBox = false }) {
  // Only truncate snippet for Featured Snippet preview
  const truncatedSnippet = isDefinitionBox && snippet && snippet.length > 300 
    ? snippet.slice(0, 300) + '...' 
    : snippet;

  // For Title & Meta preview
  const truncatedTitle = title.length > 60
    ? title.slice(0, 60) + '...'
    : title;
  const truncatedMeta = metaDesc.length > 160
    ? metaDesc.slice(0, 160) + '...'
    : metaDesc;

  // If we are in definition-box mode, show Featured Snippet preview
  if (isDefinitionBox) {
    return (
      <div className="space-y-6 font-[arial]">
        {/* Featured Snippet Box */}
        <div className="rounded-lg border border-border bg-card p-6">
          <div className="text-[#202124] text-[18px] leading-[1.58] mb-8">
            {truncatedSnippet || 'Your featured snippet will appear here'}
          </div>
          <div>
            <div className="flex items-center justify-between mb-1">
              <div>
                <div className="flex items-center gap-2 mb-1">
                  <div className="h-5 w-5 rounded-full bg-gray-200 flex-shrink-0"></div>
                  <span className="text-[#202124] text-[14px]">example.com</span>
                </div>
                <div className="text-[#4d5156] text-[12px]">https://example.com › articles › category</div>
              </div>
              <button className="p-1">
                <svg className="h-5 w-5 text-[#70757a]" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>
                </svg>
              </button>
            </div>
            <div className="text-[#1a0dab] text-[20px] leading-[1.3] hover:underline cursor-pointer">Example Page Title...</div>
          </div>
        </div>

        {/* People Also Ask */}
        <div className="space-y-2">
          <div className="flex items-center gap-2 text-[#202124]">
            <span className="text-[22px] font-normal">People also ask</span>
            <svg className="h-5 w-5 text-[#70757a]" viewBox="0 0 24 24">
              <path fill="currentColor" d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>
            </svg>
          </div>
          <div>
            <button className="w-full border-0 border-b border-[#dadce0] bg-white hover:bg-[#f8f9fa]">
              <div className="flex items-center justify-between py-[18px] text-left">
                <span className="text-[#202124] text-[16px]">What makes NY style pizza different from Chicago style?</span>
                <svg className="h-5 w-5 flex-none text-[#70757a] rounded-full bg-[#f1f3f4]" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M7 10l5 5 5-5z"/>
                </svg>
              </div>
            </button>
            <button className="w-full border-0 border-b border-[#dadce0] bg-white hover:bg-[#f8f9fa]">
              <div className="flex items-center justify-between py-[18px] text-left">
                <span className="text-[#202124] text-[16px]">How many toppings go on a supreme pizza?</span>
                <svg className="h-5 w-5 flex-none text-[#70757a] rounded-full bg-[#f1f3f4]" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M7 10l5 5 5-5z"/>
                </svg>
              </div>
            </button>
            <button className="w-full border-0 border-b border-[#dadce0] bg-white hover:bg-[#f8f9fa]">
              <div className="flex items-center justify-between py-[18px] text-left">
                <span className="text-[#202124] text-[16px]">What's the difference between Neapolitan and Sicilian?</span>
                <svg className="h-5 w-5 flex-none text-[#70757a] rounded-full bg-[#f1f3f4]" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M7 10l5 5 5-5z"/>
                </svg>
              </div>
            </button>
            <button className="w-full border-0 border-b border-[#dadce0] bg-white hover:bg-[#f8f9fa]">
              <div className="flex items-center justify-between py-[18px] text-left">
                <span className="text-[#202124] text-[16px]">Why is wood-fired pizza considered the best?</span>
                <svg className="h-5 w-5 flex-none text-[#70757a] rounded-full bg-[#f1f3f4]" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M7 10l5 5 5-5z"/>
                </svg>
              </div>
            </button>
          </div>
        </div>

        {/* Normal Search Result */}
        <div className="space-y-1">
          <div className="flex items-center gap-2 mb-1">
            <div className="h-5 w-5 rounded-full bg-gray-200 flex-shrink-0"></div>
            <div>
              <div className="text-[#202124] text-[14px]">pizzaworld.com</div>
              <div className="text-[#4d5156] text-[12px]">https://pizzaworld.com › recipes › toppings</div>
            </div>
          </div>
          <div className="text-[#1a0dab] text-[20px] leading-[1.3] hover:underline cursor-pointer mb-1">
            Why is wood-fired pizza considered the best?
          </div>
          <div className="text-[#545454] text-[14px] leading-[1.58]">
          Pizza ipsum dolor amet mozzarella garlic pineapple stuffed crust chicken wing. Mayo bbq rib stuffed crust, green bell peppers string cheese black olives.
          </div>
        </div>
      </div>
    );
  } else {
    // Title & Meta preview
    return (
      <div style={{
        maxWidth: '600px',
        margin: '0 auto 24px',
        padding: 0,
      }}>
        {/* Top line with favicon, domain, and raw URL */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          marginBottom: '4px',
        }}>
          <img
            src="https://calendar.online/favicon.ico"
            alt="Favicon"
            style={{ width: '16px', height: '16px', marginRight: '8px' }}
          />
          <span style={{
            color: '#202124',
            fontSize: '14px',
            marginRight: '8px'
          }}>
            example.com
          </span>
          <a
            href="https://www.example.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: '#202124',
              fontSize: '14px',
              textDecoration: 'none'
            }}
          >
            https://www.example.com
          </a>
        </div>

        {/* Title (blue link) */}
        <h3 style={{
          margin: 0,
          fontSize: '18px',
          lineHeight: '1.3',
          fontWeight: 'normal'
        }}>
          <a
            href="https://www.example.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: '#1a0dab',
              textDecoration: 'none'
            }}
          >
            {truncatedTitle || 'Placeholder Title'}
          </a>
        </h3>

        {/* Description snippet */}
        <div style={{
          marginTop: '4px',
          fontSize: '14px',
          lineHeight: '1.58',
          color: '#4d5156',
        }}>
          {truncatedMeta || 'Placeholder Meta Description...'}
        </div>
      </div>
    );
  }
}

export default SerpPreview; 